import useTestSeries from './useTestSeries';
import useGoalInfo from '../useGoalInfo';
import useContestOnboardingPreference from './useContestOnboardingPreference';
import useCombats from './useCombats';

const useFullTestSeriesInfo = (
  goalUID,
  testType,
  fallbackData = {},
  lps,
  combatsPreferennce,
  combatsState
) => {
  const { key: testSeriesSWRKey, testSeriesData } = useTestSeries(
    goalUID,
    testType,
    {
      fallbackData: fallbackData.testSeriesData
    }
  );

  const { key: goalInfoSWRKey, goalInfo } = useGoalInfo(goalUID, {
    fallbackData: fallbackData.goalData
  });

  const {
    key: contestOnboardingPreferenceSWRKey,
    contestOnboardingPreferenceData
  } = useContestOnboardingPreference(goalUID, {
    fallbackData: fallbackData.contestOnboardingPreferenceData
  });

  const { key: combatsSWRKey } = useCombats(
    goalUID,
    combatsPreferennce,
    combatsState,
    {
      fallbackData: fallbackData.combatsData
    }
  );

  return {
    keys: {
      testSeriesSWRKey,
      goalInfoSWRKey,
      contestOnboardingPreferenceSWRKey,
      combatsSWRKey
    },
    testSeriesData,
    goalInfo,
    contestOnboardingPreferenceData
  };
};

export default useFullTestSeriesInfo;
